import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GraduationCap } from '@phosphor-icons/react';
import { DataTable, FilterBar, FilterChip, StatusBadge } from '../../components/admin/AdminComponents';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminTutorials() {
  const [tutorials, setTutorials] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);

  const fetchTutorials = async (p = page) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (statusFilter) params.append('status', statusFilter);
      params.append('skip', p * 50); params.append('limit', '50');
      const { data } = await axios.get(`${API_URL}/api/admin-console/content/tutorials?${params}`, { withCredentials: true });
      setTutorials(data.tutorials || []); setTotal(data.total || 0);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { fetchTutorials(); }, [statusFilter, page]);

  const columns = [
    {
      key: 'title', label: 'Tutorial',
      render: (_, row) => (
        <div className="flex items-center gap-2">
          <GraduationCap size={14} weight="duotone" className="text-[#10B981]" />
          <p className="text-[13px] text-white font-medium">{row.title}</p>
        </div>
      ),
    },
    { key: 'game_name', label: 'Game', cellClass: 'hidden md:table-cell', render: v => <span className="text-[12px] text-[#888]">{v || '—'}</span> },
    { key: 'tutorial_type', label: 'Type', cellClass: 'hidden md:table-cell', render: v => <span className="text-[12px] text-[#666] capitalize">{(v || '').replace(/_/g, ' ')}</span> },
    { key: 'difficulty', label: 'Difficulty', cellClass: 'hidden lg:table-cell', render: v => <span className="text-[12px] text-[#666] capitalize">{v || '—'}</span> },
    { key: 'status', label: 'Status', render: v => <StatusBadge status={v || 'draft'} size="xs" /> },
    {
      key: 'created_at', label: 'Created', cellClass: 'hidden xl:table-cell',
      render: v => <span className="text-[11px] text-[#444]">{v ? new Date(v).toLocaleDateString() : '—'}</span>,
    },
  ];

  return (
    <div data-testid="admin-tutorials-page">
      <div className="mb-5">
        <h1 className="text-xl font-bold text-white tracking-tight" style={{ fontFamily: 'Unbounded' }}>Tutorials</h1>
        <p className="text-[13px] text-[#444] mt-0.5">{total} tutorials</p>
      </div>

      <FilterBar searchValue={search} onSearchChange={setSearch} onSearch={() => { setPage(0); fetchTutorials(0); }}
        searchPlaceholder="Search tutorials..." count={total} label="tutorials">
        {['', 'draft', 'published', 'archived'].map(s => (
          <FilterChip key={s} label={s || 'All'} active={statusFilter === s}
            onClick={() => { setStatusFilter(s); setPage(0); }} testId={`filter-status-${s || 'all'}`} />
        ))}
      </FilterBar>

      <DataTable columns={columns} data={tutorials} loading={loading} emptyMessage="No tutorials found" emptyIcon={GraduationCap}
        rowTestIdPrefix="tutorial" page={page} pageSize={50} total={total} onPageChange={setPage}
      />
    </div>
  );
}
